var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maintenance-time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-2405.000000, -869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maintenance-time",
    transform: "translate(2405.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 467,
    cy: 473,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Maintenance_line_02",
    transform: "translate(100.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(160.318182, 90.841121)",
    stroke: "#000000",
    strokeWidth: 18.1818182
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.12727273,0 L321.5,0 C331.536364,0 339.681818,8.13936449 339.681818,18.1682243 L339.681818,263.439252 C339.681818,273.468112 331.536364,281.607477 321.5,281.607477 L0,281.607477",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 354.280374,
    x2: 257.863636,
    y2: 354.280374,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.6090909,
    y1: 354.280374,
    x2: 90.3363636,
    y2: 281.607477,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.754545,
    y1: 354.280374,
    x2: 189.027273,
    y2: 281.607477,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "163.063636 176.486131 130.590909 208.934579 66.9545455 145.345794 94.2272727 118.093458 130.590909 154.429907 199.727273 85.3452336"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.118182,
    y1: 131.465271,
    x2: 188.863636,
    y2: 150.778093,
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "372.727273 45.4205607 354.545455 45.4205607 354.545455 63.588785 372.727273 63.588785"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "409.090909 45.4205607 390.909091 45.4205607 390.909091 63.588785 409.090909 63.588785"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "445.454545 45.4205607 427.272727 45.4205607 427.272727 63.588785 445.454545 63.588785"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.954545,
    y1: 185.815514,
    x2: 385.618182,
    y2: 205.128336,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.1818182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.272727,
    y1: 481.457944,
    x2: 454.545455,
    y2: 481.457944,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.1818182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.727273,
    y1: 481.457944,
    x2: 490.909091,
    y2: 481.457944,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.1818182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.090909,63.588785 L54.5454545,63.588785 L54.5454545,0 C22.7909091,11.2279626 0,41.4235514 0,77.0060187 C0,109.01843 18.6363636,136.261682 45.4545455,149.678916 L45.4545455,322.704 C18.6454545,336.130318 0,363.37357 0,395.376897 C0,430.95028 22.7909091,461.145869 54.5454545,472.373832 L54.5454545,408.785047 L109.090909,408.785047 L109.090909,472.373832 C140.845455,461.145869 163.636364,430.95028 163.636364,395.367813 C163.636364,363.355402 145,336.11215 118.181818,322.694916 L118.181818,149.678916 C144.990909,136.252598 163.636364,109.009346 163.636364,77.0060187 C163.636364,41.4235514 140.845455,11.2279626 109.090909,0 L109.090909,63.588785 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 18.1818182
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5cd3cff402513e1615eddfcd50d856e3.svg";
export { ForwardRef as ReactComponent };